import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '#app/hooks/useAppStore';
import { handleTitle } from '../../../actions/interface';
import { CenteredWrapper, Container } from '../../../pages/styles';
import { Img, ImgContainer, NotFoundContainer, Text, Title } from './styles';
import { Button } from 'finform';
import ButtonLinkWrapper from '#app/interface/ButtonLinkWrapper';
import { routes } from '#app/constants/routes';

const NotFound = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const i18n = useAppSelector((state) => state.i18n);

  useEffect(() => {
    dispatch(handleTitle('Ошибка 404'));
  }, [dispatch]);

  return (
    <Container
      style={{
        margin: routes.isCabinetPath(location.pathname) ? '0 auto' : '20px auto 0 auto',
      }}
    >
      <CenteredWrapper>
        <NotFoundContainer>
          <ImgContainer>
            <Img src={require('./images/swan.png')} />
          </ImgContainer>
          <Title>{i18n.common.notFound1}</Title>
          <Text>{i18n.common.notFound2}</Text>
          <Text>{i18n.common.notFound3}</Text>
          <ButtonLinkWrapper
            to={routes.isCabinetPath(location.pathname) ? routes.CABINET : routes.ROOT}
          >
            <Button className="style1">{i18n.common.notFound4}</Button>
          </ButtonLinkWrapper>
        </NotFoundContainer>
      </CenteredWrapper>
    </Container>
  );
};

export default NotFound;
